/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

export default {
  data: () => ({
    toasterMessage: {
      mode: null,
      text: null
    }
  }),

  methods: {
    clearMessage() {
      this.toasterMessage = {}
    },
    showMessage(text, mode = "success") {
      this.clearMessage()
      setTimeout(() => (this.toasterMessage = { mode, text }), 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/toaster.js